import { default as reducer, initialState } from "./reducers";

// export { default as types } from "./types";
// export { default as actions } from "./actions";
// export { default as epics } from "./epics";
export { default as schemas } from "./schemas";
export { reducer, initialState };

export * from "./typings";

export default reducer;
